module.exports = {"id":"211378","name":"Jackson Irvine","rating":"71","photo":"./data/images/photos/0/211378.png","club":{"name":"Hull City","logo":"./data/images/clubs/HullCity.png"},"positions":["MC","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JacksonIrvine0.json
// module id = 1867
// module chunks = 0